export const pages = {
	'boltSynopsis': { id: 'boltSynopsis', page: 'synopsis', getter: () => import(/* webpackChunkName: 'boltSynopsis' */ 'components/bolt/synopsis/synopsis') },
	'boltPreviewPanel': { id: 'boltPreviewPanel', page: 'home', getter: () => import(/* webpackChunkName: 'boltPreviewPanel' */ 'components/bolt/home/home') },
	'signUp': { id: 'signUp', page: 'iframe', getter: () => import(/* webpackChunkName: 'signUp' */ 'components/bolt/iframe/iframe') }
};
export const sections = [
	{ id: 'boltPreviewPanel', getter: () => import(/* webpackChunkName: "boltPreviewPanel" */ 'components/bolt/previewPanel/previewPanel'), component: 'previewPanel' },
	{ id: 'boltWatchMore', getter: () => import(/* webpackChunkName: "boltWatchMore" */ 'components/bolt/watchMore/watchMore'), component: 'watchMore' }
];
export const sectionsWithParent = [

];
import SidePanelLoader from 'components/bolt/sidePanelLoader/sidePanelLoader';
export { SidePanelLoader };
import VideoOverlayLoader from 'components/bolt/videoOverlayLoader/videoOverlayLoader';
export { VideoOverlayLoader };
